import { CommonEnums } from '../common.enums';
import { ListFactory } from '../caches/list.factory';
import { SessionFactory } from '../caches/session.factory';

export class NavigateUtil {
    private static instance: NavigateUtil;

    static getInstance() {
        if (!NavigateUtil.instance) {
            NavigateUtil.instance = new NavigateUtil();
        }

        return NavigateUtil.instance;
    }

    listFactory: ListFactory;
    sessionFactory: SessionFactory;


    /**
    * NavigateUtil is a singleton class, so use NavigateUtil.getInstance() method instead of creating new NavigateUtil().
    */
    private constructor() {
        this.listFactory = ListFactory.getInstance();
        this.sessionFactory = SessionFactory.getInstance();
    }

    getLoginPageUrl(): string {
        return "session/login";
    }

    getProjectUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        if (fldr_Id == -1) {
            fldr_Id = this.sessionFactory.fldr_Id;
        }

        if (fldr_ReusableFlag == '') {
            fldr_ReusableFlag = this.sessionFactory.fldr_ReusableFlag;
        }

        return 'prj/' + fldr_Id + '/' + fldr_ReusableFlag;
    }

    getDashboardUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dashboard';
    }

    getRepConnListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/conn/list';
    }

    //copy of repconnlisturl
    getRepConnListUrl2(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/conn/list';
    }

    getRepConnUrl(conn_Id: number, fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/conn/edit/' + conn_Id;
    }

    getDataObjectListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dobj/list';
    }

    getDataObjectUrl(dObj_Id: number, fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dobj/edit/' + dObj_Id;
    }

    getDesignURL(fldr_Id: number, fldr_ReusableFlag: string, reusableFlag: string, streamingFlg: string): string {
        if (reusableFlag == CommonEnums.reusableFlag.YES) {
            return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxmp/datasubflow';
        }

        if (streamingFlg == CommonEnums.streamingFlg.YES) {
            return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxmp/datastream';
        }

        if (streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
            return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxmp/dataconnect';
        }

        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxmp/dataflow';
    }

    getDesignListUrl(fldr_Id: number, fldr_ReusableFlag: string, reusableFlag: string, streamingFlg: string): string {
        return this.getDesignURL(fldr_Id, fldr_ReusableFlag, reusableFlag, streamingFlg) + '/list';
    }

    getDesignEditUrl(fldr_Id: number, fldr_ReusableFlag: string, dxMp_Id: number, reusableFlag: string, streamingFlg: string): string {
        return this.getDesignURL(fldr_Id, fldr_ReusableFlag, reusableFlag, streamingFlg) + '/edit/' + dxMp_Id;
    }

    getListPageUrlByTitle(fldr_Id: number = -1, fldr_ReusableFlag: string) {
        if (fldr_ReusableFlag == CommonEnums.flag.YES && (this.listFactory.pageTitle == CommonEnums.pageTitles.STREAM ||
            this.listFactory.pageTitle == CommonEnums.pageTitles.DATACONNECT || this.listFactory.pageTitle == CommonEnums.pageTitles.DATASTREAM)) {
                return this.getDashboardUrl(fldr_Id, fldr_ReusableFlag);
        }

        switch (this.listFactory.pageTitle) {
            case CommonEnums.pageTitles.DASHBOARD: return this.getDashboardUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.REPCONN: return this.getRepConnListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.DATAOBJECT: return this.getDataObjectListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.UDF: return this.getUDFListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.DBSEQ: return this.getDBSeqListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.PARAMETER: return this.getParamListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.DBFUN: return this.getDBFunListUrl(fldr_Id, fldr_ReusableFlag);
            case CommonEnums.pageTitles.DESIGN: return this.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.streamingFlg.NO, CommonEnums.streamingFlg.NO);
            case CommonEnums.pageTitles.DATASTREAM: return this.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.streamingFlg.NO, CommonEnums.streamingFlg.YES);
            case CommonEnums.pageTitles.DATASUBFLOW: return this.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.reusableFlag.YES, CommonEnums.reusableFlag.NO);
            case CommonEnums.pageTitles.DATACONNECT: return this.getDesignListUrl(fldr_Id, fldr_ReusableFlag, CommonEnums.streamingFlg.NO, CommonEnums.streamingFlg.DATACONNECT);
            case CommonEnums.pageTitles.STREAM: return this.getStreamListUrl(fldr_Id, fldr_ReusableFlag);

        }

    }


    getDMWizardUrl(dxMp_Id: number): string {
        return this.getProjectUrl() + '/dxmp/dataflow/dmw/' + dxMp_Id;
    }

    getDMWWizardRepConnUrl(dxMp_Id: number, conn_Id: number) {
        return this.getDMWizardUrl(dxMp_Id) + '/repconn/' + conn_Id;
    }

    getTransformEditUrl(fldr_Id: number, fldr_ReusableFlag: string, dxMp_Id: number, reusableFlag: string, streamingFlg: string, transform_Id: number, transform_Cd: string): string {
        return this.getDesignEditUrl(fldr_Id, fldr_ReusableFlag, dxMp_Id, reusableFlag, streamingFlg) + '/' + transform_Cd.toLowerCase() + '/' + transform_Id;
    }
    getDatasubflowSubTransformEditUrl(fldr_Id: number, fldr_ReusableFlag: string, dxMp_Id: number, reusableFlag: string, streamingFlg: string, transform_Id: number, subtransform_Id: number, datasubflow_Id: number, transform_Cd: string): string {
        return this.getDesignEditUrl(fldr_Id, fldr_ReusableFlag, dxMp_Id, 'N', streamingFlg) + '/' + 'transformlet' + '/' + datasubflow_Id + '/' + transform_Id + '/' + transform_Cd.toLowerCase() + '/' + subtransform_Id;
    }

    getStreamURL(fldr_Id: number, fldr_ReusableFlag: string): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxflow';
    }

    getStreamListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dxflow/list';
    }

    getStreamEditUrl(fldr_Id: number, fldr_ReusableFlag: string, dxFlow_Id: number): string {
        return this.getStreamURL(fldr_Id, fldr_ReusableFlag) + '/edit/' + dxFlow_Id;
    }

    getJobEditUrl(fldr_Id: number, fldr_ReusableFlag: string, dxFlow_Id: number, job_Id: number, job_Cd: string): string {
        return this.getStreamEditUrl(fldr_Id, fldr_ReusableFlag, dxFlow_Id) + '/' + job_Cd.toLowerCase() + '/' + job_Id;
    }

    getUDFListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/udf/list';
    }

    getUDFUrl(udf_Id: number, fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/udf/edit/' + udf_Id;
    }

    getDBFunListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dbfn/list';
    }

    getDBFunUrl(dxFun_Id: number, fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/dbfn/edit/' + dxFun_Id;
    }

    getDBSeqListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/nseq/list';
    }

    getDBSeqUrl(native_Db_Seq_Id: number, fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/nseq/edit/' + native_Db_Seq_Id;
    }
    getParamListUrl(fldr_Id: number = -1, fldr_ReusableFlag: string = ''): string {
        return this.getProjectUrl(fldr_Id, fldr_ReusableFlag) + '/pp/list';
    }
    getListUrl(obj_Cd: string, reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): string {
        if (obj_Cd == CommonEnums.codes.DATAOBJECT) {
            return this.getDataObjectListUrl();
        }

        if (obj_Cd == CommonEnums.codes.REPCONN) {
            return this.getRepConnListUrl();
        }

        if (obj_Cd == CommonEnums.codes.DESIGN) {
            //  return this.getDesignListUrl();
        }

        return '';
    }

}